export const defaultIdentitasUsaha = {
  namaPerusahaan: '',
  /** Nomor Induk Berusaha — optional free text */
  nomorNibUsaha: '',
  alamatPerusahaan: '',
  lokasiUsahaLat: null,
  lokasiUsahaLng: null,
  provinsiUsaha: '',
  kotaUsaha: '',
  kelurahanUsaha: '',
  kecamatanUsaha: '',
  rtUsaha: '',
  rwUsaha: '',
  kodePosUsaha: '',
  jumlahKaryawan: '',
  /** MIKRO | KECIL | MENENGAH | BESAR — server profile_metadata.business_scale */
  businessScale: '',
  nomorIzinEdar: '',
};

export const defaultIdentitasProduk = {
  namaProduk: '',
  isImpor: null,
  ruangLingkup: '',
  jenisProduk: '',
  merkDagang: '',
  peralatan: '',
  hargaSatuan: '',
  kapasitasProduk: '',
  uploadedFiles: [],
  jumlahOutlet: '',
  jenisKepemilikan: '',
  lokasiGudang: '',
  jumlahArmada: '',
  jumlahMaklon: '',
  agreeTerms: false,
};
